import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

import "./Hero.css";

const Hero = ({ heading, description, list, image, bgImage}) => {

  return (
    <section className={`Hero ${bgImage}`} >
    <div className={`Hero-jumbotron jumbotron jumbotron-fluid min-vh-100 d-lg-flex align-items-center pb-0 mb-lg-5 shadow`}>
      <div className="container-fluid mx-0 px-0">
        <figure className={`d-lg-none ${image}`}><div className="Hero-image-screen jumbotron " /></figure>
        <div className="row mx-0 px-0">
          <div className="Hero-group col-12 px-2 px-md-5  p-lg-5 ml-lg-5 col-lg-9 col-xl-8">
            <div className="lead">
              <h2 className="Hero-heading font-weight-light text-uppercase">{heading}</h2>
              <p>{description}</p>
              <ul className="font-weight-light list-unstyled">
                {list.map(item => (
                  <li key={list.indexOf(item)}>
                    <FontAwesomeIcon className="" icon={faCheckCircle} /> {item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
  );

}

export default Hero;